export const SERIALIZATION_QUERY_PARAM_KEY = 'serialization';
export const SERIALIZATION_KEY_SUMUP = 'sumup';
export const SERIALIZATION_KEY_LIST = 'list';
export const createSerializationQueryParam = (serializationKey) => {
    return `${SERIALIZATION_QUERY_PARAM_KEY}=${serializationKey}`;
};
